import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { FilterQuery } from '@core/types';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { GroupMembersList } from '@core/entities';

@Injectable({
  providedIn: 'root',
})
export class GroupMembersService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  get(groupId: number, queryParams?: FilterQuery): Observable<GroupMembersList> {
    return this._http.get<any>(`${this._apiUrl}/getGroupMembers/${groupId}`, { params: queryParams }).pipe(
      map((response) => {
        return {
          pagination: response.pagination,
          members: response.groups,
        } as GroupMembersList;
      }),
    );
  }
}
